<div class="text-center" style="margin-bottom: 20px">
  <h2>{{ headerTitle() }}</h2>
  <p>{{ headerSubtitle() }}</p>
</div>
<div class="content-modal">
  @for (module of modules; track module.id; let i = $index) {
    <div class="survey-question">
      <p class="survey-title">
        {{ i + 1 }}. {{ moduleLabel(module) }}
        @if (module.required) {
          <span class="survey-required" aria-hidden="true">*</span>
        }
      </p>
      <div class="survey-options" [ngClass]="{ 'grid-2': i > 0 }">
        @for (opt of module.options; track opt.value) {
          <label class="survey-option">
            <input
              type="radio"
              [name]="'survey-1-' + module.id"
              [checked]="selectedValue(i) === opt.value"
              (change)="onOptionChange(i, opt.value)"
            />
            <span [innerHTML]="optionLabel(opt)"></span>
          </label>
        }
      </div>
    </div>
  }

  @if (!isSurveyComplete) {
    <p class="survey-hint" translate>
      components.signInModalComponent.survey1CompletaTodas
    </p>
  }

  <button
    type="button"
    class="submit-btn"
    [disabled]="!isSurveyComplete"
    [attr.aria-disabled]="!isSurveyComplete"
    (click)="goToStep.emit(4)"
  >
    <span translate
      >components.signInModalComponent.survey1DosPreguntasMas</span
    >
  </button>
</div>
